/**
 * @param form {HTMLFormElement}
 * @returns {boolean}
 */
module.exports = function triggerHtml5FormValidation(form) {
    form.removeAttribute("novalidate");
    return form.checkValidity();
}